/*
* Project: BookingEngine
* Module: components/loyalty/LoyaltyActivationLinkSentModal.js
*
* Popup de éxito tras reenviar el link de activación (resendActivationLinkByEmail).
* Se renderiza en un portal sobre document.body para quedar siempre encima
* de los popups de registro, login y forgot password.
*/
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { LOYALTY_SUPPORT_EMAIL } from '../../utils/loyaltyEmailStatus';
import './loyaltyEmailStatus.css';

class LoyaltyActivationLinkSentModal extends React.Component {
  componentDidMount() {
    document.addEventListener('keydown', this.onKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown);
  }

  onKeyDown = (ev) => {
    if (ev.key === 'Escape' || ev.key === 'Esc') {
      this.props.onClose();
    }
  };

  onCloseKeyDown = (ev) => {
    if (ev.key === 'Enter' || ev.key === ' ') {
      ev.preventDefault();
      this.props.onClose();
    }
  };

  renderModal() {
    const { t, onClose } = this.props;
    return (
      <div className="loyaltyLinkSent" role="dialog" aria-modal="true" aria-labelledby="loyaltyLinkSentTitle">
        <div className="loyaltyLinkSent__backdrop" onClick={onClose} />
        <div className="loyaltyLinkSent__card">
          <span
            role="button"
            tabIndex={0}
            aria-label={t('Close')}
            className="loyaltyLinkSent__close"
            onClick={onClose}
            onKeyDown={this.onCloseKeyDown}
          >
            <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
              <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </span>

          <svg className="loyaltyLinkSent__icon" viewBox="0 0 64 64" aria-hidden="true">
            <circle cx="32" cy="32" r="32" fill="#52C41A" />
            <path d="M19 33l9 9 17-19" fill="none" stroke="#FFFFFF" strokeWidth="5"
              strokeLinecap="round" strokeLinejoin="round" />
          </svg>

          <h2 id="loyaltyLinkSentTitle" className="loyaltyLinkSent__title">
            {t('Link sent successfully')}
          </h2>
          <p className="loyaltyLinkSent__text">{t('Check your email.')}</p>
          <p className="loyaltyLinkSent__text">
            {t('We have sent you a new link to complete your registration.')}
          </p>

          <div className="loyaltyLinkSent__help">
            <span>{t('Need help?')}</span>
            <a href={`mailto:${LOYALTY_SUPPORT_EMAIL}`}>{t('Contact us')}</a>
          </div>
        </div>
      </div>
    );
  }

  render() {
    if (typeof document === 'undefined') {
      return null;
    }
    return ReactDOM.createPortal(this.renderModal(), document.body);
  }
}

LoyaltyActivationLinkSentModal.propTypes = {
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default LoyaltyActivationLinkSentModal;
